import NotificationBar from 'components/notifications/NotificationBar';
import PreferencesCta from '../preferences/PreferencesCta';
import Braze from 'shared/Braze';
const brazeObj = new Braze();

export const debounce = (func, timeout = 1500) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
};

export const throttle = (callback, delay) => {
    let wait = false;

    return (...args) => {
        if (wait) {
            return;
        }

        callback(...args);
        wait = true;
        setTimeout(() => {
            wait = false;
        }, delay);
    };
};

export const dispatchCustomEvent = (element, eventType, data) => {
    if (!element) {
        console.error('Element is no valid');
        return;
    }

    element.dispatchEvent(
        new CustomEvent(eventType, {
            bubbles: true,
            cancelable: true,
            detail: { content: data },
        }),
    );
};

export const isVideoPlaying = (video) => {
    return (
        video.currentTime > 0 &&
        !video.paused &&
        !video.ended &&
        video.readyState > video.HAVE_CURRENT_DATA
    );
};

export const showToast = (message, status) => {
    let notificationBar = new NotificationBar();
    notificationBar.showMessage(message, status);
    notificationBar.setAutoHide(3000);
};

export const interpolateUrl = (string, values) =>
    string.replace(/{(.*?)}/g, (_, offset) => values[offset]);

export const isBrowserNotificationGranted = () => {
    if (PreferencesCta.browserIsNotificationCapable()) {
        return Notification.permission === 'granted';
    } else {
        return false;
    }
};

export const getCurrentPageRowPosition = (wrapper) => {
    let mainComponents = $('.hero__wrapper, .grid-view, .js-le-carousel');

    let itemMainParent = wrapper.parents('.js-le-carousel');
    if (itemMainParent.length === 0) {
        itemMainParent = wrapper.parents('.grid-view');
    }

    let position = null;
    mainComponents.each(function (index, element) {
        let $element = $(element);
        if ($element.html() === itemMainParent.html()) {
            position = index;
        }
    });

    return position.toString();
};

export const getDivVisibility = (divBeingChecked) => {
    const windowHeight = $(window).height(),
        docScroll = $(document).scrollTop(),
        divPosition = divBeingChecked.offset().top,
        divHeight = divBeingChecked.height(),
        hiddenBefore = docScroll - divPosition,
        hiddenAfter = divPosition + divHeight - (docScroll + windowHeight);

    if (docScroll > divPosition + divHeight || divPosition > docScroll + windowHeight) {
        return 0;
    } else {
        let result = 100;

        if (hiddenBefore > 0) {
            result -= (hiddenBefore * 100) / divHeight;
        }

        if (hiddenAfter > 0) {
            result -= (hiddenAfter * 100) / divHeight;
        }

        return Math.round(result);
    }
};

export const calculatePosition = (
    carouselElement,
    expandedWidth,
    expandedHeight,
    expandedElement,
) => {
    const initial = carouselElement.getBoundingClientRect();

    // gutter from _breakpoint.scss
    let margin = 20;

    if (window.innerWidth >= 1440) {
        margin = 47.5;
    }

    let positionObj = {};

    let leftCoordinate = initial.x + initial.width / 2 - expandedWidth / 2; // initial calculation to put element in center of carousel item
    let lastItemCheck = leftCoordinate + expandedWidth;
    leftCoordinate = leftCoordinate <= margin ? margin : leftCoordinate; // if leftmost point goes past left margin, set it at the left margin

    // if rightmost point goes past right margin, set at right margin
    if (lastItemCheck >= window.innerWidth - margin) {
        // scoot it over when it's the last item
        setTimeout(() => {
            if (expandedElement) {
                expandedElement.style.left =
                    document.body.clientWidth - expandedWidth - margin + 'px';
            }
        }, 75);
    }

    positionObj.left = leftCoordinate + 'px';

    let bodyStyle = document.body.currentStyle || window.getComputedStyle(document.body);
    let bodyTopMargin = parseInt(bodyStyle.marginTop) ?? 0;
    let topCoordinate = initial.y - (expandedHeight - initial.height) / 2 - bodyTopMargin; // place in center of carousel element
    let bottomCoordinate = topCoordinate + expandedHeight;

    // if top of expanded goes past visible, set top point at the top of the screen, same for bottom
    if (topCoordinate <= 0) {
        if (bodyTopMargin <= 0) {
            positionObj.top = window.scrollY + 25 + 'px';
        } else {
            /* this is due to the browse page having a bodyTopMargin of 144 and other like search does not */
            positionObj.top = -56 + window.scrollY + 'px';
        }
    } else if (bottomCoordinate >= window.innerHeight) {
        positionObj.top = window.scrollY - 25 + window.innerHeight - expandedWidth + 'px';
    } else {
        positionObj.top = topCoordinate + window.scrollY + 'px';
    }

    return positionObj;
};

export const handleBrazeNotification = (callback) => {
    brazeObj
        .requestBrowserNotificationPermission()
        .then(() => {
            callback();
        })
        .catch((err) => {
            console.log('Notifications permission denied', err);
        });
};

export const dispatchEventToAllCarousels = (event) => {
    document.querySelectorAll('.carousel').forEach((carousel) => carousel.dispatchEvent(event));
};
